import { useHistory } from "react-router-dom"
import { BaseContainer } from "../../components/container"
import { makeStyles } from "@material-ui/core"
import { BackButton } from "../../components/buttons/back_btn"
import TestPdfDocument from "../../assets/pdf/sample_childhood_schedule.pdf";
import PdfGBRPreJuly2024 from "../../assets/pdf/schedule_gbr_pre_july_2024.pdf";
import PdfGBRPostJuly2024 from "../../assets/pdf/schedule_gbr_post_july_2024.pdf";
import { PdfEmbed } from "../../components/pdf_embed"
import { PageTitle } from "../../components/page_sections"
import Typography from "../../components/typography"

const useStyles = makeStyles(() => ({
    pdfViewContainer: {
        height: '100%',
        overflow: 'hidden',
    },
    pdfViewContent: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 0 0',
        overflow: 'hidden',
    }
}))

export const VaccinationScheduleHKG = () => {
    const classes = useStyles()
    const history = useHistory()

    return (
        <BaseContainer noHeader className={classes.pdfViewContainer} contentWrapperClass={classes.pdfViewContent}>

            <PageTitle icon={
                <BackButton onClick={() => {
                    history.push('/discover')
                }}/>
            }>
                Hong Kong Vaccine Schedule
            </PageTitle>

            <PdfEmbed document={TestPdfDocument} />
        </BaseContainer>
    )
}

export const VaccinationScheduleGBRPreJuly2024 = () => {
    const classes = useStyles()
    const history = useHistory()

    return (
        <BaseContainer noHeader className={classes.pdfViewContainer} contentWrapperClass={classes.pdfViewContent}>

            <PageTitle icon={
                <BackButton onClick={() => {
                    history.push('/discover')
                }}/>
            }>
                UK Vaccine Schedule
                <Typography variant="bodyTextMedium">
                    (Born BEFORE 1 July 2024)
                </Typography>
            </PageTitle>

            <PdfEmbed document={PdfGBRPreJuly2024} />
        </BaseContainer>
    )
}

export const VaccinationScheduleGBRPostJuly2024 = () => {
    const classes = useStyles()
    const history = useHistory()

    return (
        <BaseContainer noHeader className={classes.pdfViewContainer} contentWrapperClass={classes.pdfViewContent}>

            <PageTitle icon={
                <BackButton onClick={() => {
                    history.push('/discover')
                }}/>
            }>
                UK Vaccine Schedule
                <Typography variant="bodyTextMedium">
                    (Born AFTER 1 July 2024)
                </Typography>
            </PageTitle>

            <PdfEmbed document={PdfGBRPostJuly2024} />
        </BaseContainer>
    )
}
